import UserCenter from './UserCenter';
import InBox from './InBox';
import CompanyInfo from './CompanyInfo';
import AppStore from './AppStore';
import Network from './Network';  
import CompanyRegister from './Network/CompanyRegister';
import PublicCompanyRegister from './Network/PublicCompanyRegister';
import HelpCenter from './HelpCenter';
import Organization from './Organization';
import Document from './Document';
import UserMange from './UserManage'; 
import GettingStarted from './GettingStarted'; 

export default {

    /** 收件箱 */
    InBox,

    /** 用户中心 */
    UserCenter,

    /** 公司信息 */
    CompanyInfo,

    /** app应用 */
    AppStore,

    /** 网络 */
    Network, 
    
    /** 帮助中心 */
    HelpCenter,

    /** 部门管理 */
    Organization,

    /** 单据 */
    Document,
    /** 用户管理 */
    UserMange,
    
    /** 网络管理，邀请公司注册 */
    CompanyRegister, 

    /** 公共链接邀请注册 */
    PublicCompanyRegister,

    /** 引导页 */
    GettingStarted,
};



// WEBPACK FOOTER //
// ./src/display/platform/index.ts